import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LoginComponent} from './login/login.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {SearchDebuggerComponent} from './search-debugger/search-debugger.component';
import {MonitorsComponent} from './monitors/monitors.component';
import {ShippingSystemComponent} from './shipping-system/shipping-system.component';
import {
    ShippingMissingCoordinatesComponent
} from './shipping-missing-coordinates/shipping-missing-coordinates.component';
import {ShipmentDriversComponent} from './shipment-drivers/shipment-drivers.component';
import {ShipmentRoutesComponent} from './shipment-routes/shipment-routes.component';
import {ShipmentDriverDetailComponent} from './shipment-driver-detail/shipment-driver-detail.component';
import {ShipmentrouteDetailComponent} from './shipment-route-detail/shipment-route-detail.component';
import {AuthGuard} from '@hassel-it/angular-common';
import {PickerQueueComponent} from './picker-queue/picker-queue.component';
import {PriceRobotProductsComponent} from './price-robot-products/price-robot-products.component';
import {PriceRobotCompetitorsComponent} from './price-robot-competitors/price-robot-competitors.component';
import {PriceRobotCompetitorComponent} from './price-robot-competitor/price-robot-competitor.component';
import {PriceRobotRulesListComponent} from './price-robot-rules-list/price-robot-rules-list.component';
import {PriceRobotRulesComponent} from './price-robot-rules/price-robot-rules.component';
import {PriceRobotProductComponent} from './price-robot-product/price-robot-product.component';
import {ShipmentStatsComponent} from './shipment-stats/shipment-stats.component';
import {UserManagerComponent} from './user-manager/user-manager.component';
import {UserEditComponent} from './user-edit/user-edit.component';
import {ShipmentsControlComponent} from './shipments-control/shipments-control.component';
import {ShipmentHelpComponent} from './shipment-help/shipment-help.component';
import {ShipmentStateComponent} from './shipment-state/shipment-state.component';
import {ShipmentDetailsComponent} from "./shipment-details/shipment-details.component";
import {ShipmentUtilitiesComponent} from "./shipment-utilities/shipment-utilities.component";
import {PriceRobotDashboardComponent} from "./price-robot-dashboard/price-robot-dashboard.component";
import {PickingListComponent} from "./picking-list/picking-list.component";
import {NotificationsComponent} from "./notifications/notifications.component";
import {ControlDashboardComponent} from "./control-dashboard/control-dashboard.component";
import {FinishResetPasswordComponent} from "./finish-reset-password/finish-reset-password.component";
import {PickingListActionsComponent} from "./picking-list-actions/picking-list-actions.component";
import {PickingListsComponent} from "./picking-lists/picking-lists.component";

const routes: Routes = [
    {path: '', component: DashboardComponent, canActivate: [AuthGuard]},
    {path: 'login', component: LoginComponent},
    {
        path: 'reset',
        component: FinishResetPasswordComponent,
    },
    {path: 'price-robot/competitors', component: PriceRobotCompetitorsComponent, canActivate: [AuthGuard]},
    {path: 'price-robot/dashboard', component: PriceRobotDashboardComponent, canActivate: [AuthGuard]},
    {path: 'price-robot/competitor/:competitorId', component: PriceRobotCompetitorComponent, canActivate: [AuthGuard]},
    {path: 'price-robot/products', component: PriceRobotProductsComponent, canActivate: [AuthGuard]},
    {path: 'price-robot/product/:productId', component: PriceRobotProductComponent, canActivate: [AuthGuard]},
    {path: 'price-robot/rules', component: PriceRobotRulesListComponent, canActivate: [AuthGuard]},
    {path: 'price-robot/rule/:ruleId', component: PriceRobotRulesComponent, canActivate: [AuthGuard]},
    {path: 'users', component: UserManagerComponent, canActivate: [AuthGuard]},
    {path: 'user', component: UserEditComponent, canActivate: [AuthGuard]},
    {path: 'user/:userId', component: UserEditComponent, canActivate: [AuthGuard]},
    // Simple nav routes
    {path: 'kontrol', component: ControlDashboardComponent, canActivate: [AuthGuard]},
    {
        path: 'shipment-control',
        redirectTo: 'kontrol/shipment-control'
    },
    {
        path: 'kontrol/shipment-control',
        component: ShipmentsControlComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'notifications', component: NotificationsComponent, canActivate: [AuthGuard]
    },
    {path: 'picking-list',   redirectTo: 'kontrol/picking-list'},
    {
        path: 'kontrol/picking-list',
        component: PickingListComponent,
        canActivate: [AuthGuard],
    }, {
        path: 'kontrol/picking-lists',
        component: PickingListsComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'kontrol/picking-list-actions-pick',
        component: PickingListActionsComponent,
        canActivate: [AuthGuard],
        data: {mode: 'pick'}
    },{
        path: 'kontrol/picking-list-actions-pack',
        component: PickingListActionsComponent,
        canActivate: [AuthGuard],
        data: {mode: 'pack'}
    },
    {
        path: 'shipment-utilities',
        redirectTo: 'kontrol/shipment-utilities'
    },
    {
        path: 'kontrol/shipment-utilities',
        component: ShipmentUtilitiesComponent,
        canActivate: [AuthGuard],
    },
    {path: 'shipping-system', redirectTo: 'kontrol/shipping-system'},
    {
        path: 'kontrol/shipping-system',
        component: ShippingSystemComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'shipping-system-search',
       redirectTo: 'kontrol/shipping-system-search'
    },
    {
        path: 'kontrol/shipping-system-search',
        component: ShippingSystemComponent,
        canActivate: [AuthGuard],
        data: {searchMode: true}
    },
    {path: 'shipping-missing-coordinates', component: ShippingMissingCoordinatesComponent, canActivate: [AuthGuard]},
    {path: 'shipment/:shipmentId/state', component: ShipmentStateComponent, canActivate: [AuthGuard]},
    {path: 'shipment', component: ShipmentDetailsComponent, canActivate: [AuthGuard]},
    {path: 'shipment/:shipmentId', component: ShipmentDetailsComponent, canActivate: [AuthGuard]},
    {
        path: 'shipment-routes',
        component: ShipmentRoutesComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'shipment-help',
        component: ShipmentHelpComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'shipment-routes/:shipmentRouteId',
        component: ShipmentrouteDetailComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'shipment-drivers',
        component: ShipmentDriversComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'shipment-drivers/:shipmentDriverId',
        component: ShipmentDriverDetailComponent,
        canActivate: [AuthGuard],
    },
    {
        path: 'picker-queue',
        component: PickerQueueComponent,
        canActivate: [AuthGuard]
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        relativeLinkResolution: 'legacy',
        onSameUrlNavigation: 'reload',
        initialNavigation: 'enabledNonBlocking'
    })],
    exports: [RouterModule]
})

export class AppRoutingModule {
}
